module.exports = __webpack_public_path__ + "media/application/images/svgs/book-open-ef784e46391d443e90a4c57c1ff314ba.svg";